import { generatePath, Redirect, Route, Switch } from 'react-router-dom'
import routes from 'app/routes'
import { useAppSelector } from 'app/hooks'
import { homeJobSelector } from 'features/home/selectors'
import NetworkStatus from './NetworkStatus'
import NetworkWLANs from './NetworkWLANs'
import WLANEditCreate from './NetworkWLANs/WLANEditCreate'
import NetworkAccessPoints from './NetworkAccessPoints'
import NetworkClients from './NetworkClients'
import NetworkAlerts from './NetworkAlerts'
import { useNetworkHomeJobsRouteParams } from '../hooks'

function NetworkDashboard() {
  const { rootDomainId, homeId } = useNetworkHomeJobsRouteParams()
  const homeJob = useAppSelector(homeJobSelector.data)

  return (
    <Switch>
      <Route exact path={routes.networkAi.dashboard.root}>
        <NetworkStatus />
      </Route>
      <Route path={routes.networkAi.dashboard.networkWLANs}>
        <NetworkWLANs />
      </Route>
      <Route path={routes.networkAi.dashboard.editCreateWLANs}>
        <WLANEditCreate />
      </Route>
      <Route path={routes.networkAi.dashboard.accessPoints}>
        <NetworkAccessPoints />
      </Route>
      <Route path={routes.networkAi.dashboard.networkClients}>
        <NetworkClients />
      </Route>
      <Route path={routes.networkAi.dashboard.networkAlerts}>
        <NetworkAlerts />
      </Route>
      <Route path="*">
        <Redirect
          to={generatePath(routes.networkAi.dashboard.root, {
            rootDomainId,
            jobId: homeJob?.id,
            homeId,
          })}
        />
      </Route>
    </Switch>
  )
}

export default NetworkDashboard
